import React from 'react';

import PlayerHeadshot from '~/components/PlayerHeadshot/PlayerHeadshot';
import StyledComponent from '~/components/Styled/Styled';

import getOr from '~/util/getOr';

import css from '~/components/PlayerRecordCard/PlayerRecordCard.scss';

type Props = {
  eventStatus: string;
  playerRecord: any;
  mappings: any;
};

class PlayerRecordCard extends React.Component<Props> {
  static displayName = 'PlayerRecordCard';

  render() {
    const { eventStatus, playerRecord, mappings } = this.props;
    const playerProperty = mappings.player.property;
    const name = getOr(playerRecord, `${playerProperty}.first_initial_and_last_name`, '');
    const player = playerRecord[playerProperty];
    const playerNumber = getOr(playerRecord, `${playerProperty}.car.number`, null);
    // reversing a shallow copy of the statHeaders because 'float: right' is applied sequentially
    const statHeaders = (mappings.eventStats[eventStatus] || []).slice(0).reverse();
    return (
      <div className={css.playerRecordContainer}>
        <div className={css.playerHeadshotContainer}>
          <PlayerHeadshot size="tiny" player={player} />
        </div>
        <div className={css.playerName}>{name}</div>
        {playerNumber && <div className={css.playerNumber}>&nbsp;({playerNumber})</div>}

        {statHeaders.map(stat => (
          <div className={css.stat} key={stat.label}>
            {getOr(playerRecord, stat.property, '-')}
          </div>
        ))}
      </div>
    );
  }
}

export default StyledComponent(PlayerRecordCard, [css]);
